import { getDefaultExportFromCjs as s } from "./contact-channels155.js";
import { __require as r } from "./contact-channels106.js";
var a = r();
const t = /* @__PURE__ */ s(a);
export {
  t as default
};
//# sourceMappingURL=contact-channels66.js.map
